import React from "react";

export const SupportHeader = () => {
  return (
    <div className="text-center">
      <h1 className="text-4xl font-bold tracking-tight text-foreground">
        How can we help you?
      </h1>
      <p className="mt-3 text-lg text-muted-foreground">
        Fill out the form below and we'll get back to you as soon as possible.
      </p>
    </div>
  );
};